<template>
    <ImplantForm />
  </template>
  
  <script>
  import ImplantForm from "@/components/ImplantForm.vue";
  
  export default {
    name: "ImportImplantPage",
    components: {
      ImplantForm
    }
  };
  </script>